import { makeStyles } from "@material-ui/core";

export const editReadinessStyles = makeStyles(theme => ({
    editIcon: {
        padding: 0
    }
}));